import { render, staticRenderFns } from "./ListChar.vue?vue&type=template&id=5c13db66&scoped=true"
import script from "./ListChar.vue?vue&type=script&lang=js"
export * from "./ListChar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13db66",
  null
  
)

export default component.exports